import { getRating, getReviews } from '../lib/api'
import { getRelativeTime, getShopConfiguration } from '../lib/utils'
import { NextSeo } from 'next-seo'
import RatingBar from '../components/RatingBar'

export default function Reviews({ rating, reviews }) {
  return (
    <>
      <NextSeo title="Reviews" description="What our customers are saying about us" />

      <section className="section py-3">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="mb-5">
                <h2 className="h2 mb-0">
                  {rating.average.toFixed(1)}{' '}
                  <small className="text-muted fw-normal fs-6">/ 5.0</small>
                </h2>
                <p className="text-muted">Average Rating</p>

                {['five', 'four', 'three', 'two', 'one'].map((n, i) => {
                  const width = ((rating[n] ?? 0) / (rating.total || 1)) * 100

                  return (
                    <div className="row align-items-center" key={n}>
                      <div className="col-9">
                        <div className="progress" style={{ height: 8 }}>
                          <div
                            className="progress-bar bg-secondary"
                            style={{ width: `${width}%` }}
                          ></div>
                        </div>
                      </div>
                      <div className="col-3 text-end">
                        <div className="d-inline-block">
                          <small className="text-muted align-top">
                            {5 - i} star{i !== 4 && 's'}
                          </small>
                        </div>
                      </div>
                    </div>
                  )
                })}

                <small className="text-muted">{rating.total} ratings</small>
              </div>
            </div>
            <div className="col-lg-7 offset-lg-1">
              <h4 className="h4 mb-0">Reviews</h4>
              <p className="text-muted mb-1">What our customers are saying about us.</p>

              <p>
                <small className="text-muted">
                  You can only submit reviews on a completed order.
                </small>
              </p>

              {reviews.map((review) => {
                return (
                  <div key={review._id} className="mb-5 border-bottom">
                    <p className="mb-0">
                      <span className="text-muted">Posted by</span>{' '}
                      {review.profile.fullname.split(' ')[0]}
                    </p>
                    <p>{getRelativeTime(review.createdAt)}</p>

                    <div className="mb-2">
                      <RatingBar size="sm" stars={review.rating} />
                    </div>

                    <p>{review.comment || <span className="text-muted">No comment.</span>}</p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export async function getServerSideProps({ req }) {
  const { props } = await getShopConfiguration(req.locals.config.shop)

  const rating = (await getRating(props.shop._id)) || {}
  const reviews = await getReviews({ shop: props.shop._id })

  const { five = 0, four = 0, three = 0, two = 0, one = 0 } = rating

  const total = five + four + three + two + one

  return {
    props: {
      ...props,
      rating: { average: 5, ...rating, total },
      reviews,
    },
  }
}
